import {
  type ModerationConfig,
  moderationConfigDto,
  type ScannerRuntimeStatus,
  scannerRuntimeStatusDto,
  type UpdateModerationConfigBody,
} from '@planuze/admin-contracts';
import { ApiError, parseJson, readErrorCode, request } from './http.js';

/* Cliente REST da config de moderação (ADR-0471). GET projeta o config LIVE do config-service
   (fastpath kill-switch + scanner); PUT faz read-modify-write no config-service via admin. */

async function configError(res: Response): Promise<ApiError> {
  const code = await readErrorCode(res);
  return new ApiError(res.status, 'server_error', code || 'request failed', code);
}

export async function getModerationConfig(): Promise<ModerationConfig> {
  const res = await request('/v1/admin/moderation-config');
  if (!res.ok) throw await configError(res);
  return parseJson(res, moderationConfigDto);
}

export async function getScannerRuntimeStatus(): Promise<ScannerRuntimeStatus> {
  const res = await request('/v1/admin/scanner-runtime');
  if (!res.ok) throw await configError(res);
  return parseJson(res, scannerRuntimeStatusDto);
}

export async function updateModerationConfig(body: UpdateModerationConfigBody): Promise<void> {
  const res = await request('/v1/admin/moderation-config', { method: 'PUT', body });
  if (!res.ok) throw await configError(res);
}
